import {createThunkEffect } from '../../utilities/ActionUtility';
import IStore from '../../models/IStore';
import EntitlementEffect from '../effects/entitlementEffect';
import EntitlementListModel, { EntitlementModel } from '../models/EntitlementModel';

export default class EntitlementActions {
  public static readonly  REQUEST_GET_ENTITLEMENT_LIST = 'EntitlementActions.REQUEST_GET_ENTITLEMENT_LIST';
  public static readonly  REQUEST_GET_ENTITLEMENT_LIST_FINISHED = 'EntitlementActions.REQUEST_GET_ENTITLEMENT_LIST_FINISHED';

  public static readonly  REQUEST_UPDATE_ENTITLEMENT = 'EntitlementActions.REQUEST_UPDATE_ENTITLEMENT';
  public static readonly  REQUEST_UPDATE_ENTITLEMENT_FINISHED = 'EntitlementActions.REQUEST_UPDATE_ENTITLEMENT_FINISHED';

  public static readonly  REQUEST_DELETE_ALL_ENTITLEMENT_OF_USER = 'EntitlementActions.REQUEST_DELETE_ALL_ENTITLEMENT_OF_USER';
  public static readonly  REQUEST_DELETE_ALL_ENTITLEMENT_OF_USER_FINISHED = 'EntitlementActions.REQUEST_DELETE_ALL_ENTITLEMENT_OF_USER_FINISHED';

  public static readonly  REQUEST_DELETE_ENTITLEMENT = 'EntitlementActions.REQUEST_DELETE_ENTITLEMENT';
  public static readonly  REQUEST_DELETE_ENTITLEMENT_FINISHED = 'EntitlementActions.REQUEST_DELETE_ENTITLEMENT_FINISHED';

  public static readonly  REQUEST_POST_ENTITLEMENT = 'EntitlementActions.REQUEST_POST_ENTITLEMENT';
  public static readonly  REQUEST_POST_ENTITLEMENT_FINISHED = 'EntitlementActions.REQUEST_POST_ENTITLEMENT_FINISHED';

  public static readonly  REQUEST_POST_ENTITLEMENT_LIST = 'EntitlementActions.REQUEST_POST_ENTITLEMENET_LIST';
  public static readonly  REQUEST_POST_ENTITLEMENT_LIST_FINISHED = 'EntitlementActions.REQUEST_POST_ENTITLEMENET_LIST_FINISHED';

  public static readonly  REQUEST_GET_ENTITLEMENT_LIST_LOGGED_USER = 'EntitlementActions.REQUEST_GET_ENTITLEMENT_LIST_LOGGED_USER';
  public static readonly  REQUEST_GET_ENTITLEMENT_LIST_LOGGED_USER_FINISHED = 'EntitlementActions.REQUEST_GET_ENTITLEMENT_LIST_LOGGED_USER_FINISHED';


public static getEntitlementList = () :any => {
  return async (dispatch: any, getState: () => IStore) => {
    return createThunkEffect(
      dispatch,
      getState(),
      EntitlementActions.REQUEST_GET_ENTITLEMENT_LIST,
      EntitlementEffect.getEntitlementList
    );
  };
};

public static updateUserEntitlement = (entitlementData: EntitlementModel):any => {
  return async (dispatch: any, getState: () => IStore) => {
    return createThunkEffect(
      dispatch,
      getState(),
      EntitlementActions.REQUEST_UPDATE_ENTITLEMENT,
      EntitlementEffect.updateEntitlement,
      entitlementData
    );
  };
};
public static deleteAllEntitlementsOfUser = (userId: string):any => {
  return async (dispatch: any, getState: () => IStore) => {
    return createThunkEffect(
      dispatch,
      getState(),
      EntitlementActions.REQUEST_DELETE_ALL_ENTITLEMENT_OF_USER,
      EntitlementEffect.deleteAllEntitlementsOfUser,
      userId,
    );
  };
};
public static deleteEntitlement = (userId: string, productId:string):any => {
  return async (dispatch: any, getState: () => IStore) => {
    return createThunkEffect(
      dispatch,
      getState(),
      EntitlementActions.REQUEST_DELETE_ENTITLEMENT,
      EntitlementEffect.deleteEntitlement,
      userId,
      productId
    );
  };
}; 

public static createEntitlement = (entitlementData: EntitlementListModel):any => {
  return async (dispatch: any, getState: () => IStore) => {
    return createThunkEffect(
      dispatch,
      getState(),
      EntitlementActions.REQUEST_POST_ENTITLEMENT,
      EntitlementEffect.createEntitlement,
      entitlementData
    );
  };
};

public static createEntitlementList = (entitlementData: EntitlementListModel[]):any => {
  return async (dispatch: any, getState: () => IStore) => {
    return createThunkEffect(
      dispatch,
      getState(),
      EntitlementActions.REQUEST_POST_ENTITLEMENT_LIST,
      EntitlementEffect.createEntitlementList,
      entitlementData
    );
  };
};

public static getEntitlementListLoggedUser = ():any => {
  return async (dispatch: any, getState: () => IStore) => {
    return createThunkEffect(
      dispatch,
      getState(),
      EntitlementActions.REQUEST_GET_ENTITLEMENT_LIST_LOGGED_USER,
      EntitlementEffect.getEntitlementListLoggedUser,
    );
  };
};

}
